import { useLayoutEffect } from 'preact/hooks';
import { useMaxSlotSize } from './useMaxSlotSize';

export function useMaxElementHeight(target: HTMLElement | null, ratio: number) {
  const maxSlotSize = useMaxSlotSize();
  useLayoutEffect(() => {
    if (!target) return;
    const maxHeight = Math.floor(maxSlotSize.width / ratio);
    target.style.maxHeight = `${maxHeight}px`;
  }, [maxSlotSize.width, target]);
}
